'use strict';
const SECTIONS=Object.freeze(['maps','atlas','atlas3d','observatory','timeline','tools']);
function normalizeWork(value){
 if(!value||value.version!==1||!SECTIONS.includes(value.section))return null;
 const personId=String(value.personId??'');
 if(personId&&!/^[1-9]\d{0,14}$/.test(personId))return null;
 if(value.toolsView!==undefined&&!['natal','transits'].includes(value.toolsView))return null;
 const toolsView=value.toolsView==='natal'?'natal':'transits';
 return {version:1,section:value.section,personId:value.section==='atlas'||value.section==='tools'&&toolsView==='transits'?'':personId,toolsView};
}
const signature=work=>{const value=normalizeWork(work);return value?JSON.stringify(value):'';};
function storedState(raw){
 try{
  const value=(typeof raw==='string'?JSON.parse(raw):raw)?.workspace;
  if(!value||!Number.isSafeInteger(value.revision)||value.revision<1)return {work:null,revision:0,updatedAt:null,activityAt:null};
  const date=v=>typeof v==='string'&&Number.isFinite(Date.parse(v))?new Date(v).toISOString():null;
  return {work:normalizeWork(value.work),revision:value.revision,updatedAt:date(value.updatedAt),activityAt:date(value.activityAt)};
 }catch{return {work:null,revision:0,updatedAt:null,activityAt:null};}
}
module.exports={SECTIONS,normalizeWork,signature,storedState};
